export default store => {
  store.subscribe((mutation, state) => {
    if (mutation.type === 'GET_GOOGLE_TOKEN') {
      window.localStorage.setItem('GOOGLE_TOKEN', mutation.payload)
    }
    if (mutation.type === 'DELETE_GOOGLE_TOKEN') {
      window.localStorage.removeItem('GOOGLE_TOKEN')
    }
  })
}



// WEBPACK FOOTER //
// ./src/vuex/plugins/google.js